import {
  axios_institute_private,
  axios_institute_public,
} from "../../../../../../api/setup.intersepter";
import { FileUploadDTO } from "./types";

export const FileUploadRequest = (body: FileUploadDTO) => {
  return axios_institute_private({
    method: "POST",
    url: `/fileUpload`,
    data: body,
  });
};

export const PublicFileUploadRequest = (body: FileUploadDTO) => {
  return axios_institute_public({
    method: "POST",
    url: `/fileUpload`,
    data: body,
  });
};
